// Meet & Assist places and the list of locations that offer the service live in
// utils/meetAssist.js, alongside the per-location rules that go with them.
// Re-exported here so the existing imports in this folder keep working.
export {
    TOKYO_STATION_PLACE_ID,
    SHINJUKU_STATION_PLACE_ID,
    SHINAGAWA_STATION_PLACE_ID,
    HANEDA_AIRPORT_PLACE_ID,
    NARITA_AIRPORT_PLACE_ID,
    MEET_SERVICE_PLACE_IDS,
    TERMINAL_SELECTION_PLACE_IDS,
} from "../../../utils/meetAssist";

export { NIGHT_HOURS, NIGHT_SURCHARGE_RATE } from "../../../utils/meetAssist";

export const PASSENGER_TITLE_OPTIONS = [
    { label: "Mr.", value: "Mr." },
    { label: "Ms.", value: "Ms." },
    { label: "Mrs.", value: "Mrs." },
];

export const PASSENGER_TITLE_WITH_EMPTY_OPTIONS = [
    { label: "Mr.", value: "Mr." },
    { label: "Ms.", value: "Ms." },
    { label: "Mrs.", value: "Mrs." },
    { label: "-", value: "-" },
];

export const TERMINAL_OPTIONS = [
    { label: "Terminal 1", value: "terminal-1" },
    { label: "Terminal 2", value: "terminal-2" },
    { label: "Terminal 3", value: "terminal-3" },
];

export const TRAVEL_AREA_OPTIONS = [
    { label: "ByTheHour.TravelArea.WithinCity", value: "withinCity" },
    { label: "ByTheHour.TravelArea.NeighboringPerfecture", value: "neighboringPerfecture" },
    { label: "ByTheHour.TravelArea.Undecided", value: "undecided" },
];

export const DATE_TIME_FORMAT = {
    "en": "MMM. Do, YYYY (ddd) HH:mm",
    "jp": "YYYY年M月D日(dd) HH:mm"
}
